import '@mdi/font/css/materialdesignicons.css'
import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import gem from '@/components/icons/gem.vue'
import emptyGem from '@/components/icons/empty-gem.vue'
// import 'vuetify/src/stylus/app.styl'
// import '../theme/default.styl'
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3b82f6',
        secondary: '#111c2d',
        accent: '#f59e0b',
        error: '#ef4444',
        success: '#22c55e',
        warning: '#f59e0b',
        info: '#3b82f6',
      }
    }
  },
  icons: {
    iconfont: 'mdi',
    values: {
      gem: {
        component: gem
      },
      emptyGem: {
        component: emptyGem
      }
    }
  },
});

